// Add filter dropdown listeners
document.addEventListener('DOMContentLoaded', function() {

    // Load more products

    // window.axios = require("axios");
    
    /*
    let products_on_page = document.querySelector('.collection-grid');
    const load_btn = document.querySelector(".custom-filter-load-more");
    let url = products_on_page.getAttribute('data-next-url');
    const spinner = document.querySelector('.load-more-spinner');
    if (load_btn) {
        if (url === '') {
            load_btn.style.display = 'none';
        }
    
        load_btn.addEventListener("click", ()=> {
    
            spinner.classList.add("show");
    
            axios.get(url, {})
                .then(function (response) {
                    data = response.data;
                    const html = document.createElement('div');
                    html.innerHTML = data;

                    let links = html.querySelector('.pagination-links').innerHTML;

                    document.querySelector('.pagination-links').innerHTML = links;
                    
                    let new_grid = html.querySelector('.collection-grid');
                    url = new_grid.getAttribute('data-next-url');
                    if (url === '') {
                        load_btn.style.display = 'none';
                    }
                    let new_products = new_grid.querySelectorAll(".product-card, .collection-advert");
    
                    new_products.forEach(new_prod => {
                        products_on_page.append(new_prod);
                    })
                    spinner.classList.remove("show");
                })
                .catch(function (error) {
                        window.log(error);
                });
    
        })
    }
    */

    let filterContainer = document.querySelectorAll(`.custom-filter`)
    
    document.addEventListener('click', event => {
        filterContainer.forEach((el) => { 
            let closeCustomFilter = el.querySelector('.filter-heading')
            let closeFilter = el.querySelector(`.filter-body`)
            
            const isClickInside = closeFilter.contains(event.target)
            const isFilterTitle = closeCustomFilter.contains(event.target)
            if (isFilterTitle) {
                el.classList.toggle('open')
            } else if (!isClickInside) {
                el.classList.remove('open')
            }
        })
    })


    let mobile_control = document.querySelector(".mobile-filter-heading")
    let filter_body = document.querySelector(".custom-filter-wrapper")

    if(mobile_control && filter_body){
        mobile_control.addEventListener('click', () => {
            // rotate svg
            if(mobile_control.classList.contains("open")){
                mobile_control.classList.remove("open")
            } else {  
                mobile_control.classList.add("open")
            }

            // open filters
            if(filter_body.classList.contains("open")){
                filter_body.classList.remove("open")
            } else {  
                filter_body.classList.add("open")
            }
        })
    }

    // Hide reset filters when no filters active
    const reset_filters = document.querySelectorAll('.reset a');
    const selected_filters = document.querySelector('.selected-filters-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filters-wrapper *');
    
    if (selected_filters_html.length > 0) {
        reset_filters.forEach(reset_filter => {
            reset_filter.style.display = 'inline-block';
        })
        selected_filters.classList.remove("no-filters");
    } else {
        selected_filters.classList.add("no-filters");
    }

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            collection_grid.classList.add("loading")
        })
    })

    // Submit form on input change

    const filter_inputs = document.querySelectorAll('.sort-container select, .filter-container-wrapper input');
    const filter_form = document.querySelector('.filter-container');
    const collection_grid = document.querySelector('.collection-grid');
    const filters = document.querySelectorAll('.filter-container input')
    filter_inputs.forEach(input => {
        input.addEventListener('change', () => {
            collection_grid.classList.add("loading")
            filters.forEach(filter => {
                if (filter.checked == true) {

                    console.log("FILTER",filter)
                }
            })
            filter_form.submit()
        })
    })

    // Show active filter count in mobile heading

    const filter_bodies = document.querySelectorAll('.custom-filter .filter-body');
    const filter_total_count_el = document.querySelector('.mobile-filter-heading span');
    let total_count = [];

    filter_bodies.forEach(filter_body => {
        let active_count = [];
        let disabled_count = [];
        const filter_count_el = filter_body.previousElementSibling.querySelector('.filter-count');
        const inputs = filter_body.querySelectorAll('input');
        inputs.forEach(input => {
            if (input.checked == true) {
                active_count.push(1);
                disabled_count.push(1);
            }
            if (input.disabled == true) {
                disabled_count.push(1);
            }
        })
        if (active_count.length > 0) {
            filter_count_el.innerHTML = `(${active_count.length})`;
        }
        if (inputs.length == disabled_count.length) {
            filter_body.parentNode.classList.add('disabled');
        }
    })
    if (total_count.length > 0) {
        filter_total_count_el.innerHTML = `(${total_count.length})`;
    }
})